// this is an autogenerated file from App/Account/Content/Settings/Content/Procedures/ActionsAction/Content/Content/CopyAction/query.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_Procedures_ActionsAction_Content_Content_CopyAction($location_ids: [uuid!]!, $procedure_ids: [numeric!]!) {
  vaxiom_sys_organizations(where: { _id: { _in: $location_ids } }) {
    id
  }
  vaxiom_procedures(where: { id: { _in: $procedure_ids } }) {
    id
    name
    description
    requires_diagnosis
    requires_images
    sys_created
    sys_last_modified
  }
}

`